// Store listing watch: what Google Play shows per locale, read daily by the
// worker, and the changes it confirmed (lib/store-listing-watch.ts).
import { api } from './client';

export type ListingField =
  | 'title' | 'short_description' | 'full_description' | 'icon' | 'feature' | 'screenshots' | 'video' | 'developer';

export interface ListingValues {
  title?: string;
  short_description?: string;
  full_description?: string;
  icon?: string;
  feature?: string;
  screenshots?: string[];
  video?: string;
  developer?: string;
}

export interface ListingChange {
  id: number;
  lang: string;
  fields: ListingField[];
  before: ListingValues;
  after: ListingValues;
  detected_at: number;
  /** 0 card pending, 1 card sent, 2 alerts were off */
  notified: number;
}

export interface ListingWatchLocale {
  lang: string;
  geo: string | null;
  checked_at: number | null;
  attempted_at: number | null;
  last_error: string | null;
  changed_at: number | null;
}

export interface ListingWatch {
  locales: ListingWatchLocale[];
  changes: ListingChange[];
}

export const getListingChanges = (appId: string) =>
  api.get<ListingWatch>(`/admin/apps/listing-changes/${appId}`);

export const checkListingNow = (appId: string) =>
  api.post<{ lang: string; outcome: string }[]>(`/admin/apps/listing-changes/${appId}/check`);
